import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {SelectItem} from 'primeng/api';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../../core/configs/app-config';
import { HttpClient } from '@angular/common/http';
import {WeekObject} from '../../../model/dto/werkbon/werkbon';
import { ActivatedRoute  } from '@angular/router';
import {FormControl} from '@angular/forms';
import {formatDate} from '@angular/common';
//import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import SignaturePad from 'signature_pad';
import {DatePipe} from '@angular/common';
import {UserService } from "../../../core/services/user.service";
import { User } from '../../../model/dto/user'
import { AuthService } from '../../../core/services/auth.service';
@Component({
    selector   : 'werkbon',
    templateUrl: './werkbon.component.html',
    styleUrls  : ['./werkbon.component.scss']
})



export class WerkbonComponent implements OnInit, AfterViewInit
{

    config: any;

    weekDagenLijst: WeekObject [] = [new WeekObject(1, "Maandag"), new WeekObject(2, "Dinsdag"), new WeekObject(3, "Woensdag"),
    new WeekObject(4, "Donderdag"), new WeekObject(5, "Vrijdag"), new WeekObject(6, "Zaterdag"), new WeekObject(7, "Zondag")];

    loggedUser: User = this.userService.getCurrentUser();
    userRoles: string[] = JSON.parse(localStorage.getItem('userRoles'));
    opgeslagen: boolean = false;
    selectedMedewerker: number = 0;
    afdelingen: SelectItem[] = [];
    selectedAfdelingen: any[] = [];
    selectedBedrijf: number;
    selectedContact: number;
    bedrijven: SelectItem[] = [];
    medewerkers: SelectItem[] = [];  
    WeekNr: any;
    Jaar: any;
    selectedWeekDatum: any;
    projectNumber: string = "";
    disableBtnBewaar:boolean = false;
    disableCbBedrijf: boolean = false;
    disableCbContact: boolean = false;
    defaultDate: Date;
    defaultPauzeDate: Date;
    Status: boolean = true;
    Error: string = "";
    disableBtnVolgende : boolean = true;
    FormControl = new FormControl('');
    tab2: boolean = false;
    tab3: boolean = false;
    selectedIndex: number = 0;
    startDayNumber: number;
    currentWeekDay: any;
    maandag: any;
    dinsdag: any;
    woensdag: any;
    donderdag: any;
    vrijdag: any;
    zaterdag: any;
    zondag: any;
    Omschrijving: any;
    werkOmschrijving: any;
    geleverdeMaterialen: any;
    oldSelectedIndex: number;
    zonderTabKlik: boolean = true;
    cbBestaandPlanning: boolean = true;
    planningOnderwerpen: SelectItem[] = [];  
    selectedPlanningOnderwerp: number;
    @ViewChild('sPad', {static: true}) signaturePadElement;
    signaturePad: any;
/*     public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
      'minWidth': 5,
      'canvasWidth': 300,
      'canvasHeight': 300,
      'backgroundColor': "rgb(255,255,255)"
    }; */

    /**
     * Constructor
     *
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     */
    
    constructor(private authService: AuthService, public datepipe: DatePipe, private route: ActivatedRoute, private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService: UserService, @Inject(HttpClient) private http?: HttpClient)
    {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          };
        this._fuseTranslationLoaderService.loadTranslations(english, dutch);

    }

    ngAfterViewInit() {
      // this.signaturePad is now available
      
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
      this.signaturePad.backgroundColor = "rgb(247, 230, 230)";
      this.signaturePad.clear();
      //this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
      //this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
   
    drawClear(){
      this.signaturePad.clear();
    }
    drawComplete() {
      // will be notified of szimek/signature_pad's onEnd event
      console.log(this.signaturePad.toDataURL());
    }
   
    drawStart() {
      // will be notified of szimek/signature_pad's onBegin event
      console.log('begin drawing');
    }

    ngOnInit(): void { 


      this.cbBestaandPlanning = true;
      this.selectedWeekDatum = new Date();

      this.defaultDate = new Date();
      this.defaultDate.setMinutes(0)

      this.defaultPauzeDate = new Date();
      this.defaultPauzeDate.setHours(0);
      this.defaultPauzeDate.setMinutes(45);

      // ISO week date weeks start on monday, so correct the day number
      this.startDayNumber = (this.selectedWeekDatum.getDay() + 6) % 7;
      // Set the target to the thursday of this week so the
      // target date is in the right year
      this.selectedWeekDatum.setDate(this.selectedWeekDatum.getDate() - this.startDayNumber + 3);
      // ISO 8601 states that week 1 is the week with january 4th in it
      var jan4:any = new Date(this.selectedWeekDatum.getFullYear(), 0, 4);
      this.Jaar = this.selectedWeekDatum.getFullYear();
      // Number of days between target date and january 4th
      var dayDiff = (this.selectedWeekDatum - jan4) / 86400000;

      if (new Date(this.selectedWeekDatum.getFullYear(), 0, 1).getDay() < 4) {
        this.WeekNr = 1 + Math.ceil(dayDiff / 7);
      }
      else {  // jan 4th is on the next week (so next week is week 1)
        this.WeekNr = Math.ceil(dayDiff / 7);
      }

      this.currentWeekDay = new Date();
      this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber);
      this.currentWeekDay = formatDate(this.currentWeekDay, 'EEEE d MMMM y', 'en');

      for(let i=0; i < this.weekDagenLijst.length; i++){
        this.weekDagenLijst[i].Datum = new Date();
        this.weekDagenLijst[i].Datum.setDate(this.weekDagenLijst[i].Datum.getDate() - this.startDayNumber + i); 
        this.weekDagenLijst[i].Datum =  formatDate(this.weekDagenLijst[i].Datum, 'EEEE d MMMM y', 'en');
      }

      let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/departments/overview";

      if( this.userRoles.indexOf("chef") > -1 ) {
          var get = this.http.get(conString);
          console.log(conString);
          get.subscribe(     
          (results:any) => {
          for (var result of results){ 
              this.afdelingen.push(<SelectItem>{ label:result["Afdeling"], value:result["AfdID"]});
              if (result["AfdID"] == this.authService.getLoggedInUser().AfdID) {
                this.selectedAfdelingen.push(result["AfdID"]);
                this.selectedAfdelingen = this.selectedAfdelingen.slice();
                this.onAfdelingChange();
              } 
            }  
          },
          (error) => {
          console.error(error);
          });
          console.log("success");
      } else {
          var get = this.http.get(conString);
          console.log(conString);
          get.subscribe(     
          (results:any) => {
          for (var result of results){ 
              if (result["AfdID"] == this.authService.getLoggedInUser().AfdID) {
                this.afdelingen.push(<SelectItem>{ label:result["Afdeling"], value:result["AfdID"]});
                this.selectedAfdelingen.push(result["AfdID"]);
                this.selectedAfdelingen = this.selectedAfdelingen.slice();
                this.onAfdelingChange();
              }          
            }
          },
          (error) => {
          console.error(error);
          });
      }


        
      }

      async loadCompanies(BestaandPlanning: boolean){
        this.bedrijven = [];
        this.selectedBedrijf = null;
        console.log(this.selectedMedewerker);
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/werkbon/companies";
        var body = {
          "CompanyFromPlanning":BestaandPlanning,
          "Week": this.WeekNr,
          "Year": this.Jaar,
          "EmployeeID": this.selectedMedewerker	
        };
        let promise = await new Promise(async (resolve, reject) => {
          await this.http.post(conString, body).toPromise().then(
            json => {
              let userObject: any = json;
              for (var result of  userObject){ 
                  this.bedrijven.push(<SelectItem>{ label:result["Bedrijf"], value:result["BedrijfID"]});
                  console.log(this.bedrijven);
                }  
                resolve();
            }, error => {
              reject(false);
            }
          )
        });
        return promise;
      }

      loadPlanningOnderwerpen(){
        console.log("tesdas");
        this.planningOnderwerpen = [];
        this.selectedPlanningOnderwerp = null;
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/werkbon/planningsubjects";
        var body = {
          "Week": this.WeekNr,
          "Year": this.Jaar,
          "EmployeeID": this.selectedMedewerker,
          "CompanyID": this.selectedBedrijf	
        };
        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
        for (var result of  results){ 
            this.planningOnderwerpen.push(<SelectItem>{ label:result["Onderwerp"], value:result["OnderwerpID"]});
          }  
        },
        (error) => {
        console.error(error);
        }); 
      }

      onMedewerkerChange(){
        this.Status = true;
        this.loadCompanies(this.cbBestaandPlanning);
        if (this.cbBestaandPlanning) {
          this.loadPlanningOnderwerpen();
        }
      }

      onCompanyChange(){
        this.Status = true;
          this.loadPlanningOnderwerpen();
      }

      onAfdelingChange() {
        this.Status = true;
        this.medewerkers = [];
      let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/filter";
        var body = {
          "AfdIDs": this.selectedAfdelingen,
          "Zoektext": "",
          "UitDienst" : false
         };
         console.log(body);
        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
          for (var result of results){ 
            if( this.userRoles.indexOf("chef") > -1 ) {
              this.medewerkers.push(<SelectItem>{label:result["CplNaam"] + ' - ' + result["Afdeling"], value:result["MedewerkerID"]});           
            } else {
              if (result["MedewerkerID"] == this.authService.getLoggedInUser().MedewerkerID) {
                this.medewerkers.push(<SelectItem>{label:result["CplNaam"] + ' - ' + result["Afdeling"], value:result["MedewerkerID"]}); 
                this.selectedMedewerker = result["MedewerkerID"];
                console.log(this.selectedMedewerker);
                this.loadCompanies(this.cbBestaandPlanning);
                break;
              }
            }
           
          }  
        },
        (error) => {
          console.error(error);
        });

        this.loadCompanies(this.cbBestaandPlanning);
        if (this.cbBestaandPlanning) {
          this.loadPlanningOnderwerpen();
        }
      }

      onKlantUitPlanningChange(event){

        this.selectedPlanningOnderwerp = null;
 
        if (this.cbBestaandPlanning == false && this.projectNumber == "") {
          this.loadCompanies(false);
        } else if (this.cbBestaandPlanning == false) {
          this.onLeaveProjectNumber();
        } else {
          if (this.selectedBedrijf > 0) {
            this.onLeaveProjectNumber();
          } else {
            this.loadCompanies(this.cbBestaandPlanning);
          }
        }
   
        if (this.cbBestaandPlanning) {
          this.loadPlanningOnderwerpen();
        } 
      }


      onWeekDatumChange(event){
        var target:any = new Date(event.value.valueOf());
        var test = new Date(event.value);
        // ISO week date weeks start on monday, so correct the day number
        this.startDayNumber = (test.getDay() + 6) % 7;
        // Set the target to the thursday of this week so the
        // target date is in the right year
        target.setDate(target.getDate() - this.startDayNumber + 3);
        // ISO 8601 states that week 1 is the week with january 4th in it
        var jan4:any = new Date(target.getFullYear(), 0, 4);
        this.Jaar = target.getFullYear();
        // Number of days between target date and january 4th
        var dayDiff = (target - jan4) / 86400000;

        if (new Date(target.getFullYear(), 0, 1).getDay() < 4) {
          this.WeekNr = 1 + Math.ceil(dayDiff / 7);
        }
        else {  // jan 4th is on the next week (so next week is week 1)
          this.WeekNr = Math.ceil(dayDiff / 7);
        }

        this.currentWeekDay = new Date(event.value.valueOf());
        this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber);
        this.currentWeekDay = formatDate(this.currentWeekDay, 'EEEE d MMMM y', 'en');

        for(let i=0; i < this.weekDagenLijst.length; i++){
          this.weekDagenLijst[i].Datum = new Date(event.value.valueOf());
          this.weekDagenLijst[i].Datum.setDate(this.weekDagenLijst[i].Datum.getDate() - this.startDayNumber + i); 
          this.weekDagenLijst[i].Datum =  formatDate(this.weekDagenLijst[i].Datum, 'EEEE d MMMM y', 'en');
        }

        this.loadCompanies(this.cbBestaandPlanning);
      }

       onLeaveProjectNumber(){
        // indien juiste projectnummer dus 18 tekens dan automatisch een klant kiezen anders melding dat hij zelf klant moet kiezen
        if (this.projectNumber.length == 18) {
          // projectnummer klopt nu kijken of het bestaat
          // indien hij bestaat de bedrijfid eruit halen en terug geven
          
          let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/projecten/bedrijf";
          var body = {
            "Projectnummer": this.projectNumber,
           };
           console.log(body);
          var post = this.http.post(conString, body);
          post.subscribe( async (results:any) => {
            for (var result of results.Bedrijf){                            
              this.Error = "";
              this.disableBtnBewaar = true;
              await this.loadCompanies(false);
              this.selectedBedrijf = result["BedrijfID"];
              this.disableCbBedrijf = true; 
            } 

            this.Status = results.Status["Succeed"]; 
          },
          (error) => {
            console.error(error);
            this.disableBtnBewaar = false;
            this.disableCbBedrijf = false;
          });

          if (this.Status == false) {
            this.Error = "Dit projectnummer bestaat niet!";
            this.disableBtnBewaar = false;
            this.disableCbBedrijf = false;
            this.loadCompanies(this.cbBestaandPlanning);
          }
        } else if (this.projectNumber.length > 0){
          this.Status = false;
          this.Error = "Een projectnummer heeft 18 cijfers!";
          this.disableBtnBewaar = false;
          this.disableCbBedrijf = false;
          this.loadCompanies(this.cbBestaandPlanning);
        } else {
          this.Status = true;
          this.Error = "";
          this.disableBtnBewaar = false;
          this.disableCbBedrijf = false;
        }
      }

      volgendeTab(){
        if (this.selectedMedewerker == 0 || this.selectedMedewerker == null) {
          this.Error = "Kies een medewerker!";
          this.Status = false;
          return;
        }

        if (this.selectedWeekDatum == "" || this.selectedWeekDatum == null) {
          this.Error = "Kies een Weekdatum!";
          this.Status = false;
         return;
        }

        if (this.selectedBedrijf == 0 || this.selectedBedrijf == null) {
          this.Error = "Kies een Klant!";
          this.Status = false;
          return;
        }

        if (this.Status == true) {
          this.tab2 = true;
          this.selectedIndex = this.selectedIndex + 1;
        } 

      }
      
      terugTab(){
        this.selectedIndex = this.selectedIndex - 1;
      }
      
  tabChanged(event){
    this.selectedIndex = event.index;

    if (this.selectedIndex > 0 && this.selectedIndex < 8) {
    
      this.currentWeekDay = new Date(this.currentWeekDay);
      this.startDayNumber = (this.currentWeekDay.getDay() + 6) % 7;

      switch(this.selectedIndex) {
        case 1: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber);
        break;
        }
        case 2: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 1);
          break;
        }
        case 3: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 2);
          break;
        }
        case 4: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 3);
          break;
        }
        case 5: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 4);
          break;
        }
        case 6: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 5);
          break;
        }
        case 7: {
          this.currentWeekDay.setDate(this.currentWeekDay.getDate() - this.startDayNumber + 6);
          break;
        }
      }
      this.tab3 = true;
      this.currentWeekDay = formatDate(this.currentWeekDay, 'EEEE d MMMM y', 'en');
    }      
  }

  onOpslaanWerkBon(){

    if (this.opgeslagen == false) {
      var ingevuld1dag = false;
      // kijken of de uren wel kloppen
      for(var i = 0; i < this.weekDagenLijst.length; i++) {
        console.log(this.weekDagenLijst[i].Vertrek);
        if (this.weekDagenLijst[i].Vertrek && this.weekDagenLijst[i].Aankomst && this.weekDagenLijst[i].Pauze && this.weekDagenLijst[i].Terug && this.weekDagenLijst[i].Thuis) {
          
          if (this.weekDagenLijst[i].Aankomst < this.weekDagenLijst[i].Vertrek) {
            console.log("test");
            this.Error = this.weekDagenLijst[i].Dag + " Aankomst moet hoger zijn dan vertrek!";
            this.Status = false;
            return;
          } 
  
          if (this.weekDagenLijst[i].Terug < this.weekDagenLijst[i].Aankomst) {
            console.log("test");
            this.Error = this.weekDagenLijst[i].Dag + " Terug moet hoger zijn dan Aankomst!";
            this.Status = false;
            return;
          } 
  
          if (this.weekDagenLijst[i].Thuis < this.weekDagenLijst[i].Terug) {
            console.log("test");
            this.Error = this.weekDagenLijst[i].Dag + " Thuis moet hoger zijn dan Terug!";
            this.Status = false;
            return;
          } 

          ingevuld1dag = true;
        } else {
          if (this.weekDagenLijst[i].Vertrek) {
            this.Error = this.weekDagenLijst[i].Dag + " Je hebt niet alle velden ingevoerd!";  
            this.Status = false;
            return;
          }
        }
      
     }

     if (!ingevuld1dag) {
      this.Error = "Je hebt geen 1 dag ingevuld!";  
      this.Status = false;
      return;
     }

     console.log(this.Jaar);
        console.log(this.weekDagenLijst);
        var body = {
          "WerkBonID": 0,
          "BedrijfID": this.selectedBedrijf,
          "MedewerkerID": this.selectedMedewerker,
          "OnderwerpID": this.selectedPlanningOnderwerp,
          "GeleverdeMaterialen": this.geleverdeMaterialen,
          "WeekRegels": this.weekDagenLijst,
          "KlantHandtekening": this.signaturePad.toDataURL(),
          "Project": this.projectNumber,
          "WeekNr": this.WeekNr,
          "Jaar": this.Jaar,
          "WerkOmschrijving": this.werkOmschrijving,
          "Omschrijving": this.Omschrijving,
          "WeekDatum": this.selectedWeekDatum,
        };
        console.log(body);
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/werkbon/save";

        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
          console.log(results.Status);
          console.log(results.Status.Succeed);
          console.log(results.Status["Succeed"]);
      //  for (var result of  results){ 
          if (results.Status["Succeed"] == true) {
            alert("opslaan gelukt");
            this.opgeslagen = true;
          }
      //  }       
         
        },
        (error) => {
        console.error(error);
        });
    } else {
      alert("Dit is al opgeslagen!");
    }
    
  }

  onBewaarWerkBon(){
    if (this.opgeslagen == false) {
      var ingevuld1dag = false;
        // kijken of de uren wel kloppen
        for(var i = 0; i < this.weekDagenLijst.length; i++) {
          console.log(this.weekDagenLijst[i].Vertrek);
          if (this.weekDagenLijst[i].Vertrek && this.weekDagenLijst[i].Aankomst && this.weekDagenLijst[i].Pauze && this.weekDagenLijst[i].Terug && this.weekDagenLijst[i].Thuis) {
            
            if (this.weekDagenLijst[i].Aankomst < this.weekDagenLijst[i].Vertrek) {
              console.log("test");
              this.Error = this.weekDagenLijst[i].Dag + " Aankomst moet hoger zijn dan vertrek!";
              this.Status = false;
              return;
            } 
    
            if (this.weekDagenLijst[i].Terug < this.weekDagenLijst[i].Aankomst) {
              console.log("test");
              this.Error = this.weekDagenLijst[i].Dag + " Terug moet hoger zijn dan Aankomst!";
              this.Status = false;
              return;
            } 
    
            if (this.weekDagenLijst[i].Thuis < this.weekDagenLijst[i].Terug) {
              console.log("test");
              this.Error = this.weekDagenLijst[i].Dag + " Thuis moet hoger zijn dan Terug!";
              this.Status = false;
              return;
            } 

            ingevuld1dag = true;
          } else {
            if (this.weekDagenLijst[i].Vertrek) {
              this.Error = this.weekDagenLijst[i].Dag + " Je hebt niet alle velden ingevoerd!";  
              this.Status = false;
              return;
            }
          }
        
      }

      if (!ingevuld1dag) {
        this.Error = "Je hebt geen 1 dag ingevuld!";  
        this.Status = false;
        return;
      }

          console.log(this.weekDagenLijst);
          var body = {
            "WerkBonID": 0,
            "BedrijfID": this.selectedBedrijf,
            "MedewerkerID": this.selectedMedewerker,
            "OnderwerpID": this.selectedPlanningOnderwerp,
            "GeleverdeMaterialen": this.geleverdeMaterialen,
            "WeekRegels": this.weekDagenLijst,
            "KlantHandtekening": this.signaturePad.toDataURL(),
            "WeekNr": this.WeekNr,
            "Jaar": this.Jaar,
            "WerkOmschrijving": this.werkOmschrijving,
            "Omschrijving": this.Omschrijving,
            "WeekDatum": this.selectedWeekDatum,
          };
          console.log(body);
          let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/werkbon/bewaar";

          var post = this.http.post(conString, body);
          post.subscribe(     
          (results:any) => {
            console.log(results.Status);
            console.log(results.Status.Succeed);
            console.log(results.Status["Succeed"]);
        //  for (var result of  results){ 
            if (results.Status["Succeed"] == true) {
              alert("bewaren gelukt");
              this.opgeslagen = true;
            }
        //  }       
          
          },
          (error) => {
          console.error(error);
          });
      } else {
        alert("Dit is al opgeslagen!");
      }
  }
}

